
import React, { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import Select from 'react-select'
import Axios from 'axios';
import Swal from "sweetalert2";
import { API_BASE_URL, INSERT_SUB_CATEGORY, GET_DDL } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const AddSubcategory = () => {

    const [userDataSession, setUserDataSession] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    // const [formData, setFormData] = useState({
    //     OrgId: `${userDataSession.OrgId}`,
    //     Name: "",
    //     Description: "",
    //     IsDefault: false,
    //     IsActive: "1",
    //     CreatedBy: `${userDataSession.UserId}`,
    //     Code: "",
    //     Qty: "",
    // });
    
    const initialFormData = {
        OrgId: userDataSession.OrgId,
        Name: "",
        Description: "",
        IsDefault: false,
        CreatedBy: userDataSession.UserId,
        Code: "",
        Qty: 0,
    };

    const [formData, setFormData] = useState(initialFormData);


    const handleCancel = () => {
        setFormData(initialFormData);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };    

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);
    
        let updatedFormData = { ...formData };
    
        // Update the fields as needed
        updatedFormData.CreatedBy = userDataSession.UserId;
        updatedFormData.OrgId = userDataSession.OrgId;
        updatedFormData.Description = formData.Description === "" ? "NULL" : formData.Description;
        updatedFormData.Qty = 0;
        updatedFormData.IsDefault = formData.IsDefault === true ? 1 : 0;
    
        console.log(updatedFormData, 'sending data to api');
    
        Axios.post(`${API_BASE_URL}${INSERT_SUB_CATEGORY}`, updatedFormData)
            .then(response => {
                console.log(response.data.ResultData, 'response');
                if (response.data.ResultData[0]['Status'] === 'Success') {
                    setSubmitBtnLoading(false);
                    
                    // Fetch the service data here after successful post
                    fetchDDLData(); 
    
                    Swal.fire({
                        title: `Sub-Category added Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload(); // Reload page after confirmation
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
                console.log('Category added successfully:', response.data);
            })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error('Error adding category:', error);
            });
    };
    
    // Function to fetch service data
    const fetchDDLData = () => {
        if (userDataSession && userDataSession.OrgId) {
            Axios.get(
                `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`
            )
            .then((response) => {
                if (response.data) {
                    const allData = response.data.ResultData;
    
                    // Define the DDL names to filter
                    const ddlNames = [
                        "Supplier",
                        "CATEGORY",
                        "Subcategories",
                        "Products",
                        "variantypes",
                        "TAX",
                        "Stores",
                        "BRAND",
                        "Roles",
                        "Staff",
                        "Customers",
                        "UNITS",
                    ];
    
                    // Iterate through each DDL name, filter data, and save to session storage
                    ddlNames.forEach((name) => {
                        const filteredData = allData.filter(
                            (item) => item.DDLName === name
                        );
                        sessionStorage.setItem(
                            `filteredDDLData_${name}`,
                            JSON.stringify(filteredData)
                        );
                    });
    
                    console.log("Filtered data saved successfully");
                } else {
                    console.error("Error fetching data:", response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
        }
    };
    
    

    return (
        <div>
            {/* Add Sub Category */}
            {submitBtnLoading&&(<SpinLoader/>)}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightSubCategoryAdd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Add Sub Category</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-1">
                            <label className="form-label">Name<span className="fw-bold text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Sub CategoryName'
                                name="Name"
                                value={formData.Name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-1">
                            <label className="form-label">Code<span className="fw-bold text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='SubCategory Code'
                                name="Code"
                                value={formData.Code}
                                onChange={handleChange}
                                maxLength={5}
                                required
                            />
                        </div>
                        {/* <div className="mb-1">
                            <label className="form-label">Quantity</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Quantity'
                                name="Qty"
                                value={formData.Qty}
                                onChange={handleChange}
                            />
                        </div> */}
                        <div className="mb-1 input-blocks">
                            <label className="form-label">Description</label>
                            <textarea
                                className="form-control"
                                placeholder='Description'
                                name='Description'
                                value={formData.Description}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-0">
                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                <span className="status-label">IsDefault</span>
                                <input
                                    type="checkbox"
                                    id="user2"
                                    className="check"
                                    name="IsDefault"
                                    checked={formData.IsDefault}
                                    onChange={handleChange}
                                />
                                <label htmlFor="user2" className="checktoggle"></label>
                            </div>
                        </div>
                        
                        <div className="modal-footer-btn">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                onClick={handleCancel}
                                 disabled={submitBtnLoading}
                            >
                                Cancel
                            </button>
                            <button type='submit' className="btn btn-submit"
                             disabled={submitBtnLoading}>
                                {submitBtnLoading ? 'Submitting..' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {/* /Add Category */}
        </div>
                    
    )
}

export default AddSubcategory
